import React from 'react';
import { get, size } from 'global/lib/lodash';
import useStyles from './ScorecardToggle.styles';
import { ButtonGroup, Button } from '@material-ui/core';
import ScoreIcon from 'global/components/ScoreIcon';

export default (props) => {
  const { scores, scorecards, setScorecardIndex, scorecardIndex, activeEdit } = props;
  const classes = useStyles();

  const show = size(scores) > 1;

  return !show ? null : (
    <ButtonGroup value={scorecardIndex} variant="contained" disableElevation size="small" className={classes.container}>
      {scorecards.map((di, i) => {
        const selected = scorecardIndex === i;
        const score = get(scores[get(di, 'id')], 'calculatedScore');
        return (
          <Button
            disableElevation
            color={selected ? 'primary' : undefined}
            startIcon={score && <ScoreIcon score={score} />}
            // disable scorecard toggling if Edit mode is enabled
            disabled={!selected && typeof activeEdit === 'object'}
            onClick={() => setScorecardIndex(i)}
          >
            {get(di, 'name', `Scorecard ${i + 1}`)}
          </Button>
        );
      })}
    </ButtonGroup>
  );
};
